import { render, staticRenderFns } from "./JDMatchCard.vue?vue&type=template&id=28941a06&scoped=true"
import script from "./JDMatchCard.vue?vue&type=script&lang=js"
export * from "./JDMatchCard.vue?vue&type=script&lang=js"
import style0 from "./JDMatchCard.vue?vue&type=style&index=0&id=28941a06&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28941a06",
  null
  
)

export default component.exports